import React from "react";
import { checkTextTranslation, getObject, setObject, translate } from "../../utils/useful";
import SelectInput from "./SelectInput";
import SwitchInput from "./SwitchInput";
import FormViewer from "../FormViewer";
import FixedView from "../FixedView";
import { event } from "d3";

// used for making the prop types of this component
// import PropTypes from "prop-types";

class PriceInput extends React.Component {
    state = {
        value: '',
        showValue: '',
        headers: [
            { key: 'base', type: 'PriceInput', col: '12', maxWidth: '50%', information: { label: this.props.header?.information?.label, placeholder: this.props.header?.information?.placeholder, required: this.props.header?.information?.required } },
            { key: 'onSale', type: 'SwitchInput', col: "12", information: { label: '{{lang}}On sale', required: false, default: false }, showMain: true },

            {
                key: 'discount.value', type: 'PriceInput', col: '12', maxWidth: '50%', information: {
                    label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                    unit: { key: 'discount.unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                },
                dependencies: [{
                    refKey: 'onSale', targetKey: 'discount.value',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.onSale' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,

                }]
            },
            {
                key: 'final', type: 'PriceInput', col: '12', maxWidth: '50%', information: { label: '{{lang}}Sale price', placeholder: '{{lang}}Sale price', required: false },
                dependencies: [{
                    refKey: 'onSale', targetKey: 'final',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.onSale' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,

                }]
            },

        ]
    }

    componentDidMount() {
        if (this.props.data != null) {

            this.setState({ value: this.props.data, showValue: this.changeToPriceValue(this.props.data) })
        }
        if (this.props.inplaceView) {
            setTimeout(() => {
                this.setState({ show: true })
            }, 10);
        }
    }

    componentDidUpdate(prevProps) {

        // console.log(this.props.header?.key, this.props.data)

        if (this.props.data != this.state.value && (!isNaN(this.props.data) && !isNaN(this.state.value))) {

            if ((this.props.data != null && this.props.data != undefined && !isNaN(this.props.data)) || this.state.showValue != '-')
                this.setState({ value: this.props.data, showValue: this.changeToPriceValue(this.props.data) })
        }
    }

    handleChange(evt) {

        // console.log("handleChange",evt.target.validity.valid)
        if (evt.target.validity.valid) {
            if (!evt.target.value.includes('-') || evt.target.value.lastIndexOf('-') == 0) {
                let value = ''
                let minus = false
                if (evt.target.value != "") {
                    value = evt.target.value.replace(new RegExp(',', 'g'), '')
                    if (value != '-') {
                        // value = Number(value)
                        minus = (Number(value) < 0) ? true : false

                    } else {
                        minus = true

                    }
                } else {
                    value = ''
                    minus = false
                }

                this.setState({ minus: minus })
                // console.log(value)
                let newValue = parseFloat(value)
                if (isNaN(newValue)) {
                    newValue = null
                }



                // if (newValue != null) {
                // this.setState({ value, showValue: this.changeToPriceValue(String(value)) });
                this.props.changeValue(this.props.header.key, newValue, this.props.extra)
                // }
                if (value === '-' && this.props.header.information?.negativeAllowed) {
                    newValue = '-'
                }

                // console.log(newValue )
                // console.log(this.changeToPriceValue(newValue) )
                let showValue = this.changeToPriceValue(newValue)

                if (value) {
                    let lastChar = value[value.length - 1]
                    if (lastChar == '.') {
                        showValue = showValue + '.'
                    }
                }

                this.setState({ value, showValue });

            }
        }
    }

    conditionalSettings(param, condition) {
        if (this.props.header.information.settings) {
            if (this.props.header.information.settings[param] == condition) {
                return true
            }
        }
        return false
    }



    changeToPriceValue(Svalue) {
        let value = typeof Svalue == 'object' ? ((Svalue?.final != null && Svalue?.final != undefined) ? String(Svalue.final) : null) : (Svalue != null ? String(Svalue) : null)
        // console.log(value)
        let final = ''
        let minus = false

        if (value != null) {
            if (parseFloat(value) < 0) {
                // console.log(value)
                minus = true
                value = value.replace('-', '')
            }

            let fullValue = String(value).split('.')
            // console.log(fullValue[0])
            let newValue = fullValue[0]

            newValue = String(newValue).split('')
            let count = 0
            for (let i = newValue.length - 1; i >= 0; i--) {
                final = newValue[i] + final
                count++
                if (count == 3 && i != 0) {
                    final = ',' + final
                    count = 0
                }
            }

            final = final + (value.includes('.') ? ('.' + (fullValue[1] ? fullValue[1] : '')) : '')
        } else {
            return ''
        }
        // console.log(minus ? ('-' + final) : final)
        return minus ? ('-' + final) : final
    }


    changeUnitValue = (key, value, extra) => {

        console.log(key, value, extra)
        this.props.changeValue(key, value, this.props.extra)
    }

    discountLiveChange = (data, init, key, value, extra, full) => {

        // console.log(key)
        // console.log(value)

        let base = data?.base ?? 0
        let final = base

        let myObject = data

        if ((key == 'base' && !data?.onSale) || key == 'onSale' || key == 'discount.unit') {
            this.form.changeValue('discount.value', 0, null, null, true)
            this.form.changeValue('final', base, null, null, true)

            setObject(myObject, 'discount.value', 0)
            setObject(myObject, 'final', base)

        }


        if ((key == "discount.value" || key == 'base') && data?.onSale) {

            let discountValue = getObject(data, "discount.value") ?? 0
            let discountType = getObject(data, "discount.unit") ?? 'percent'

            if (discountType == 'percent') {
                final = base - (base * (discountValue / 100))
            } else {
                final = base - discountValue
            }


            final = Math.round(final * 100) / 100

            this.form.changeValue('final', final, null, null, true)

            setObject(myObject, 'final', final)


        }

        if (key == "final" && data?.onSale) {

            let discountValue = base - value

            this.form.changeValue('discount.value', discountValue, null, null, true)
            this.form.changeValue('discount.unit', 'amount', null, null, true)

            setObject(myObject, 'discount.value', discountValue)
            setObject(myObject, 'discount.unit', 'amount')

        }


        this.props.changeValue(this.props.header.key, myObject, this.props.extra)



    }


    openfixView = () => {

        this.fixView.showView()
        setTimeout(() => {
            this.fixView.getBounding()
        }, 1);

    }

    changeFixedValue = (key, value, extra) => {
        // console.log("changeFixedValue")
        // console.log(key)
        // console.log(value)

        this.props.changeValue(key, value, extra)
        this.setState({ value: value, showValue: this.changeToPriceValue(value) })
        setTimeout(() => {
            this.fixView.getBounding()
        }, 1);
    }

    render() {
        let info = this.props.header.information
        let pattern = "^[.,0-9]+$"
        if (info.negativeAllowed) {
            pattern = "^[-.,0-9]+$"
        }

        let unit

        if (info.unit) {
            let fullData = this.props.rowData ?? this.props.fullData
            unit = getObject(fullData, info.unit?.key) ?? info.unit?.information?.defaultValue

            // console.log(info.unit?.information?.defaultValue)
        }


        let leftIndicator = info?.leftIndicator
        let rightIndicator = info?.rightIndicator

        if (leftIndicator == '{{currency}}') {
            leftIndicator = this.props.variables?.currency ?? '$'
        }

        if (rightIndicator == '{{currency}}') {
            rightIndicator = this.props.variables?.currency ?? '$'
        }
        // console.log("unit",unit)

        // console.log(pattern)
        // console.log(this.state.value)

        return (
            <div className='mt-0 w-100 flexc flex-1' ref={el => this.firstCurrentNode = el}>

                {((this.props.inplaceView || info.inplaceView) && info.withDiscount) ? (
                    <>
                        <button className="w-100 flex-1 flexcb" onClick={() => this.openfixView()}>
                            {(this.state.showValue && this.state.showValue != '') ? (
                                <p>{this.state.showValue}</p>
                            ) : (
                                <p className="placeholder"> {this.props.information?.placeholder ?? translate('Value ...')}</p>
                            )}
                            {this.state.value?.onSale && (
                                <div className="br-4 px-2 py-1" style={{ backgroundColor: '#10101010' }}>
                                    <p className="text-smallest color-gray-1 text-semibold">{translate("Sale")}</p>
                                </div>
                            )}
                        </button>
                        {this.state.show && (
                            <FixedView onHide={() => this.setState({ fixed: true })} ref={el => this.fixView = el} nodeRef={this.firstCurrentNode} showFocus={false} fixed={this.state.fixed} topOffset={7} bottomOffset={22} xOffset={0} zIndex={20} width={240} >
                                <div className=" px-1 py-1  d-flex flex-column w-100 " style={{ boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 10 }}>

                                    <PriceInput header={this.props.header} data={this.props.data} changeValue={this.changeFixedValue} variables={this.props.variables} setFormStatus={this.setFormStatus} extra={this.props.extra} inputClass={'bordered-input'} />

                                </div>

                            </FixedView>
                        )}

                    </>
                ) : (


                    <>
                        {info.leftIndicator && (
                            <p className="prd-2 pld-1 opacity-7">{leftIndicator}</p>
                        )}


                        {!info.withDiscount && (

                            <input pattern={pattern} step="0.01" onInput={this.handleChange.bind(this)} onChange={() => { }} disabled={info?.disabled} value={this.state.showValue ? this.state.showValue : ''} placeholder={checkTextTranslation(info.placeholder)} className="transpanet-input" />
                        )}


                        {info.withDiscount && (
                            <div className="w-100">
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} liveChange={this.discountLiveChange} initData={this.props.data} data={this.props.data} width={this.props.width} errors={this.state.errors} formClass="none" inputClass={this.props.inputClass} variables={this.props.variables} setFormStatus={this.setFormStatus} scrollToTop={this.scrollToTop} nopadding={true} sectionStyle={{}} />
                            </div>
                        )}

                        {info.unit && (
                            <div className="flexcc px-1" style={{ width: 50, borderLeft: '1px solid #eee' }}>
                                <SelectInput header={info.unit} data={unit} changeValue={this.changeUnitValue} style={{ textAlign: 'center' }} extra={this.props.extra} />
                            </div>
                        )}

                        {info.rightIndicator && (
                            <p className="pld-2 pld-1 opacity-7">{rightIndicator}</p>
                        )}
                    </>

                )}
            </div>
        );
    }
}

export default PriceInput;
